import { Card } from "@aws-amplify/ui-react"
import type { ChartData, ChartOptions } from "chart.js"
import {
  BarElement,
  CategoryScale,
  Chart as ChartJS,
  Legend,
  LinearScale,
  Tooltip,
} from "chart.js"
import annotationPlugin from "chartjs-plugin-annotation"
import { Bar } from "react-chartjs-2"
import { FaRegStar, FaStar } from "react-icons/fa6"
import { StarStates } from "./ListItem"

ChartJS.register(
  BarElement,
  CategoryScale,
  LinearScale,
  Legend,
  Tooltip,
  annotationPlugin
)

type GenauigkeitBarChartProps = {
  _className?: string
  title?: string
  actions?: React.ReactNode
  data: ChartData<"bar", number[], string>
  chartOptions: ChartOptions<"bar">
  starState?: StarStates
}
export default function GenauigkeitBarChart({
  _className,
  title,
  actions,
  data,
  chartOptions,
  starState = StarStates.hidden,
}: GenauigkeitBarChartProps) {
  /**
   * @note Enough vertical space per bar so the category scale never needs to auto-skip labels.
   * Heuristic, not derived from Chart.js's actual layout — a rough guess at its default
   * bar-thickness-plus-gap (per bar) and the space its x-axis ticks/labels need (fixed offset).
   */
  const barCount = data.labels?.length ?? 0
  /** @note No upper bound: a long list grows the chart to match rather than compressing/scrolling it. */
  const chartHeightPx = Math.max(320, barCount * 36 + 60)

  return (
    <Card className={`rm-list-item ${_className}`}>
      <div className="info w-full">
        {(title || actions) && (
          <div className="title w-full !flex !items-center !justify-between gap-3">
            <span>
              {title}{" "}
              {starState === StarStates.hidden ? (
                ""
              ) : starState === StarStates.empty ? (
                <FaRegStar className="fav" />
              ) : (
                <FaStar className="fav is-fav" />
              )}
            </span>
            {actions}
          </div>
        )}
        <div
          className="details relative w-full !mt-0"
          style={{ height: `${chartHeightPx}px` }}
        >
          <Bar data={data} options={chartOptions} />
        </div>
      </div>
    </Card>
  )
}
